import type { CSSProperties, ReactElement } from 'react';

interface LineChartIconProps {
  style?: CSSProperties;
  width?: string | number;
  height?: string | number;
}

/** Trending-up line-chart glyph for the response-threshold empty state (NA-72). */
export function LineChartIcon({
  style,
  width = 40,
  height = 40,
}: LineChartIconProps): ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={width}
      height={height}
      style={style}
      aria-hidden="true"
      data-testid="line-chart-icon"
    >
      <path d="M4 3v16a1 1 0 0 0 1 1h16" />
      <path d="M7 14l4-4 3 3 5-6" />
    </svg>
  );
}

LineChartIcon.displayName = 'LineChartIcon';
